
import { Component, Vue } from 'nuxt-property-decorator'

import AppLayout from '~/components/AppLayout.vue'
import AppHeader from '~/components/AppHeader'
import AppOfflineBar from '~/components/AppOfflineBar.vue'
import AppFooter from '~/components/AppFooter.vue'
import PageDynamicBanner from '~/components/banners/PageDynamicBanner'
import AppLayoutOverlay from '~/components/AppLayoutOverlay/AppLayoutOverlay.vue'

@Component({
  components: {
    AppLayoutOverlay,
    AppLayout,
    AppHeader,
    PageDynamicBanner,
    AppFooter,
    AppOfflineBar,
  },
})
export default class DefaultLayout extends Vue {
  get isHeaderWithShadow () {
    return this.localePath('index') !== this.$route.path
  }

  get keepAliveKey () {
    return this.$route.fullPath
  }

  created () {
    if (process.client) {
      this.$analytics.emarsys.init()
    }
  }
}
